import { render } from "./Company.vue?vue&type=template&id=49cc16c6"
import script from "./Company.vue?vue&type=script&lang=ts"
export * from "./Company.vue?vue&type=script&lang=ts"

import "./Company.vue?vue&type=style&index=0&id=49cc16c6&lang=less"
script.render = render

export default script